import {
  AfterViewInit, ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {LayoutService} from '../../services/interface/layout.service';
import {ConfigService} from '../../services/interface/config.service';
import {AsyncPipe, isPlatformBrowser, JsonPipe, NgClass} from '@angular/common';
import {UntypedFormControl} from '@angular/forms';
import {LISTITEMS} from '../../shared/data/template-search';
import {Router, RouterLink} from '@angular/router';
import {AuthService} from '../../services/auth.service';
import {LocalizeRouterPipe, LocalizeRouterService} from '@gilsdav/ngx-translate-router';
import {Booking, User} from '../../../models/business-objects';
import {BookingService} from '../../services/booking.service';
import {CanonicalAndMetaService} from '../../services/canonical-and-meta.service';
import {DataService} from '../../services/data.service';
import {BehaviorSubject, Subject} from 'rxjs';
import {ChatbotService} from '../../services/chatbot.service';
import {OnDutyService} from '../../services/on-duty.service';
import {NgbDropdown, NgbDropdownMenu, NgbDropdownToggle} from '@ng-bootstrap/ng-bootstrap';
import {TooltipDirective} from 'ngx-bootstrap/tooltip';
import {MatTooltip} from '@angular/material/tooltip';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  standalone: true,
  imports: [
    RouterLink,
    NgbDropdown,
    NgbDropdownMenu,
    AsyncPipe,
    LocalizeRouterPipe,
    TranslateModule,
    NgClass,
    TooltipDirective,
    JsonPipe,
    NgbDropdownToggle,
    MatTooltip
  ],
  styleUrls: ['./nav.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class NavComponent implements OnInit, AfterViewInit, OnDestroy {
  currentLang = 'en';
  flag = 'us.png';
  toggleClass = 'ft-maximize';
  placement = 'bottom-left';
  public isCollapsed = true;
  someOneIsLogged = new BehaviorSubject<boolean>(true);
  width = 960;
  screenSize = 'L';
  showQuickAccesses : Subject<boolean>;
  selectedLanguageText = 'English';
  selectedLanguageFlag = './assets/img/flags/us.png';
  logoUrl = 'assets/img/logo.png';
  menuPosition = 'Side';
  isSmallScreen = false;
  innerWidth: any;
  searchOpenClass = '';
  transparentBGClass = '';
  hideSidebar = true;
  suffixUrl: string;
  subscriptions = [];
  inPrivateSection = new BehaviorSubject<boolean>(false);
  loggedUser= new BehaviorSubject<User>(null);
  userName= new BehaviorSubject<string>("");
  clientName= new BehaviorSubject<string>("");
  loggedUserObservable = this.loggedUser.asObservable();
  isLoaded = false;

  // On-duty staff data
  onDutyCommercialStaff = new BehaviorSubject<any[]>([]);
  onDutyCommercialStaffObservable = this.onDutyCommercialStaff.asObservable();
  private refreshInterval: any;
  @ViewChild('search') searchElement: ElementRef;
  @ViewChildren('searchResults') searchResults: QueryList<any>;

  @Output()
  toggleHideSidebar = new EventEmitter<Object>();

  @Output()
  seachTextEmpty = new EventEmitter<boolean>();

  listItems = [];
  control = new UntypedFormControl();
  public config: any = {};
  constructor(@Inject(PLATFORM_ID) private platformId: any, public translate: TranslateService,
              private layoutService: LayoutService,
              private renderer: Renderer2,
              private configService: ConfigService, private cdr: ChangeDetectorRef,
              private bookingService: BookingService, private dataService:DataService,
              private canonicalAndMetaService: CanonicalAndMetaService,
              private router: Router, private authService: AuthService,
              private chatbotService: ChatbotService,
              private onDutyService: OnDutyService,
              private localize: LocalizeRouterService) {
    this.someOneIsLogged.next(this.authService.currentUserValue != null);
    this.loggedUser.next(this.authService.currentUserValue );
    this.subscriptions.push( this.authService.currentUser.subscribe(user => {
      console.log("received user : ", user)
      this.userName.next(user? user.fullName?.toUpperCase():"")
      this.clientName.next(user? (user.cliente? user.cliente.fullName?.toUpperCase():"" ):"")
      this.someOneIsLogged.next(this.authService.currentUserValue != null);
      this.loggedUser.next(this.authService.currentUserValue );
      })
    )
    this.config = this.configService.templateConf;
    if (isPlatformBrowser(this.platformId)) {
      this.innerWidth = window.innerWidth;
    }
    this.subscriptions.push (layoutService.toggleSidebar$.subscribe(
      isShow => {
        this.hideSidebar = !isShow;
      }));
    this.currentLang = this.translate.currentLang;
    this.SetFlag(this.currentLang);
    this.showQuickAccesses = this.dataService.showQuickAccesses;
    this.inPrivateSection = this.dataService.inPrivateSection;
    if (   this.router.url.includes(this.localize.translateRoute('/dispatch') as string)
      || this.router.url.includes(this.localize.translateRoute('/client') as string)
      || this.router.url.includes(this.localize.translateRoute('/private') as string)
      || this.router.url.includes(this.localize.translateRoute('/chat') as string)
    ) {
      console.log('Nav detecta alguien en seccion privada this.router.url=' +this.router.url)
      this.inPrivateSection.next(true);
      this.showQuickAccesses.next(false);
    } else {
      console.log('Nav detecta alguien en seccion publica this.router.url=' +this.router.url)
      this.inPrivateSection.next(false);
      this.showQuickAccesses.next(true);
    }
    this.subscriptions.push (this.loggedUserObservable.subscribe(user => {
      this.userName.next( user != null? user.fullName?.toUpperCase() : "User Not Found");
      this.clientName.next( (user != null && user.cliente != null )? user.cliente.fullName?.toUpperCase() : "");
    }))
    this.loggedUser.next(this.authService.currentUserValue);
  }


  ngOnInit() {
    this.subscriptions.push (this.canonicalAndMetaService.languageChanged.subscribe(event => {
      const lang = event.lang;
      console.log('NavBar detected language change to ' + event.lang + ' Changing Flag');
      this.SetFlag(lang);
      this.cdr.detectChanges();
    }));
    this.listItems = LISTITEMS;
    if (this.innerWidth < 992) {
      this.isSmallScreen = true;
    } else {
      this.isSmallScreen = false;
    }
    if (isPlatformBrowser(this.platformId)){
      this.onResize();
    }

    // Load on-duty staff data
    this.loadOnDutyStaff();

    // Refresh on-duty staff data every 5 minutes
    if (isPlatformBrowser(this.platformId)) {
      this.refreshInterval = setInterval(() => {
        this.loadOnDutyStaff();
      }, 300000); // 5 minutes in milliseconds
    }
  }

  /**
   * Load the on-duty staff data from the API
   */
  loadOnDutyStaff() {
    // Store the subscription in the subscriptions array to ensure proper cleanup
    const subscription = this.onDutyService.getOnDutyStaff().subscribe(
      (response) => {
        if (response && response.comercial && response.comercial.length > 0) {
          // Use the commercial staff directly from the response
          this.onDutyCommercialStaff.next(response.comercial);
          console.log('On-duty commercial staff loaded:', response.comercial);
        } else {
          console.log('No on-duty commercial staff found');
          this.onDutyCommercialStaff.next([]);
        }
      },
      (error) => {
        console.error('Error loading on-duty staff:', error);
        this.onDutyCommercialStaff.next([]);
      }
    );

    // Add the subscription to the array for proper cleanup
    this.subscriptions.push(subscription);
  }

  /**
   * Get the name from the staff member
   * @param staff The staff object or name string
   * @returns The name
   */
  getStaffName(staff: any): string {
    if (!staff) return '';

    // If staff is an object with a name property
    if (typeof staff === 'object' && staff.name) {
      // Return only the first name (text before the first space)
      return staff.name.trim().split(' ')[0];
    }

    // If staff is a string (for backward compatibility)
    if (typeof staff === 'string') {
      // Return only the first name (text before the first space)
      return staff.trim().split(' ')[0];
    }

    return '';
  }

  /**
   * Get the phone number from the staff object
   * @param staff The staff object or name string (for backward compatibility)
   * @returns The phone number
   */
  getStaffPhone(staff: any): string {
    // If staff is an object with a phone property, use it
    if (staff && typeof staff === 'object' && staff.phone) {
      // Remove spaces, plus signs, dashes, and dots from phone number to ensure WhatsApp links work correctly
      return staff.phone.replace(/[\s+\-\.]/g, '');
    }
    // Fallback to default phone number
    return '573138443558';
  }
  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    if (event && (this.width !== event.target.innerWidth || this.innerWidth !== event.target.innerWidth)) {
      console.log('window resized in nav component with width change ' + event.target.innerWidth);
      this.width = event.target.innerWidth;
      this.innerWidth = event.target.innerWidth;
      if (this.innerWidth < 992) {
        this.isSmallScreen = true;
      }
      else {
        this.isSmallScreen = false;
      }
    }
    if (this.width > 1280){
      this.screenSize = 'L';
    } else if (this.width < 1280) {
      this.screenSize = 'S';
    } else {
      this.screenSize = 'S';
    }
  }
  ngAfterViewInit() {
    this.isLoaded = true;
    this.subscriptions.push(this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();
    }));
  }


  ngOnDestroy(): void {
    this.subscriptions.forEach(subs => subs.unsubscribe());

    // Clear the refresh interval to prevent memory leaks
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }

  public SetFlag(language: string){
    switch (language) {
      case 'es':
        this.selectedLanguageText = 'Spanish';
        this.selectedLanguageFlag = 'es.png';
        this.flag = 'es.png';
        break;
      case 'en':
        this.flag = 'us.png';
        this.selectedLanguageText = 'English';
        this.selectedLanguageFlag = 'us.png';
        break;
      case 'fr':
        this.flag = 'fr.png';
        this.selectedLanguageText = 'Francais';
        this.selectedLanguageFlag = 'fr.png';
        break;
      case 'de':
        this.flag = 'de.png';
        this.selectedLanguageText = 'German';
        this.selectedLanguageFlag = 'de.png';
        break;
      case 'pt':
        this.flag = 'br.png';
        this.selectedLanguageText = 'Portuguese';
        this.selectedLanguageFlag = 'br.png';
        break;
    }
  }

  async ChangeLanguage(language: string) {
    this.localize.changeLanguage(language);
  }

  loadLayout() {

    if (this.config.layout.menuPosition && this.config.layout.menuPosition.toString().trim() !== '') {
      this.menuPosition = this.config.layout.menuPosition;
    }

    if (this.config.layout.variant === 'Light') {
      this.logoUrl = 'assets/img/logo-dark.png';
    }
    else {
      this.logoUrl = 'assets/img/logo.png';
    }

    if (this.config.layout.variant === 'Transparent') {
      this.transparentBGClass = this.config.layout.sidebar.backgroundColor;
    }
    else {
      this.transparentBGClass = '';
    }

  }
  logout() {
    this.authService.logout();
    this.bookingService.updateBooking(new Booking());
    this.router.navigate([this.localize.translateRoute('/home')]).then(ok =>{}, error=>{}).then(() => {
      location.reload();
    });
  }


  toggleSidebar() {
    this.layoutService.toggleSidebarSmallScreen(this.hideSidebar);
  }

    protected readonly encodeURIComponent = encodeURIComponent;

  showChatBot(): void {
    this.chatbotService.showChatbot().then( data => {
      console.log('showChatBot finished');
    });
  }
}
